import React from "react";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";

const Layout = ({ children }) => {
  const isGettingDetails = false;

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        {isGettingDetails ? (
          // <Spinners />
          "loading"
        ) : (
          <>
            <AdminHeader />
            <AdminSidebar />
            <div className={`main-content`}>{children}</div>
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default Layout;
